"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogs = void 0;
const basic_1 = require("../basic");
const spaces_1 = require("../basic/spaces");
exports.catalogs = (0, basic_1.applyBase)({
    catalogsHeading: {
        mb: [4, 5],
        mx: [4, 0],
    },
    catalogsOrderHeading: {
        mb: [0, 3],
    },
    catalogFormSubmitButton: {
        width: ['100%', '430px'],
        position: 'relative',
    },
    catalogForm: {
        'fieldset+.error': {
            mt: -3,
        },
    },
    catalogsFormContent: {
        display: 'flex',
        mx: '-5px',
        flexWrap: 'wrap',
        mb: ['20px', 0],
    },
    catalogsListWrap: {
        p: '6px',
        pb: 1,
        '.content': {
            display: 'flex',
            justifyContent: 'space-between',
            color: 'primary',
            p: 1,
            '.catalog-links, .link-wrapper': {
                display: 'flex',
                justifyContent: 'space-between',
            },
        },
        a: {
            fontSize: '0px',
        },
    },
    catalogList: {
        display: 'grid',
        gridTemplateColumns: ['1fr 1fr', '1fr 1fr 1fr 1fr'],
        rowGap: ['20px', 3],
        columnGap: ['18px', '30px'],
        mb: ['50px', '45px'],
        mx: [4, 0],
    },
    catalogsOrderedCatalogsList: {
        display: 'grid',
        gridTemplateColumns: ['1fr', '1fr 1fr'],
        rowGap: ['20px', 3],
        columnGap: ['18px', '30px'],
        mb: [2, 5],
    },
    catalogCardWrap: {
        a: {
            width: '100%',
        },
        '.content a': {
            width: 'auto',
        },
    },
    catalogsDownloadLink: {
        marginRight: spaces_1.space[2],
        display: 'flex',
        alignItems: 'center',
    },
    catalogCardInfoFormWrap: {
        display: 'flex',
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: 'borderColor',
        py: ['10px', 3],
        maxWidth: '430px',
        width: '100%',
        mb: [5, '50px'],
        pr: 2,
        flexShrink: '0',
        '.imageWrap': {
            flexShrink: 0,
        },
    },
    catalogDeleteButtonWrap: {
        textAlign: 'end',
        pt: [3, 2],
        lineHeight: 1,
        color: 'primary',
    },
    catalogCardInfoImage: {
        display: 'block',
        width: ['75px', '87px'],
        height: '100%',
        objectFit: `cover`,
        mr: 3,
    },
    catalogCardInfoFormContent: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
        '.wrapper': {
            width: '100%',
        },
        '.heading': {
            fontSize: [2, 3],
            fontWeight: 'normal',
            mb: [1, 2],
        },
        '.catalogDates': {
            fontSize: [1, 2],
            color: 'secondary',
        },
    },
});
//# sourceMappingURL=catalogs.js.map